import { hollyMediaArray } from './hollyMedia'
import { hollyBio } from './hollyBios'

import { frodoReviewerReviewHinge, luigiReviewerReviewBumble, gatsbyReviewerReviewTinder } from './hollyReviewerReviews'
import { frodoReviewerProfile, luigiReviewerProfile, gatsbyReviewerProfile } from './hollyReviewers'

export const frodoProfileReviewHinge = {
  _id: 'frodoProfileReviewHingeId',
  userId: 'hollyUserId',
  userEmail: 'holly@email.com',
  datingProfileId: 'hollyDatingProfileHingeId',
  reviewerProfileId: 'frodoReviewerProfileId',
  reviewerEmail: 'frodo@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: hollyMediaArray[11]._id,
      mediaItemURL: hollyMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[11].type,
      caption: hollyMediaArray[11].captions[0],
      subcaption: hollyMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[9]._id,
      mediaItemURL: hollyMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[9].type,
      caption: hollyMediaArray[9].captions[0],
      subcaption: hollyMediaArray[9].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[12]._id,
      mediaItemURL: hollyMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[12].type,
      caption: hollyMediaArray[12].captions[0],
      subcaption: hollyMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[5]._id,
      mediaItemURL: hollyMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[5].type,
      caption: hollyMediaArray[5].captions[0],
      subcaption: hollyMediaArray[5].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[4]._id,
      mediaItemURL: hollyMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[4].type,
      caption: hollyMediaArray[4].captions[0],
      subcaption: hollyMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[1]._id,
      mediaItemURL: hollyMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[1].type,
      caption: hollyMediaArray[1].captions[0],
      subcaption: hollyMediaArray[1].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look stylish! And the pastry gives it a humorous touch! Good start!`,
      verdict: 'Very',
    },
    {
      feedback: `Amazing smile! And stylish hat! You look great here!`,
      verdict: 'Very',
    },
    {
      feedback: `A fun casual picture is a nice light touch after the two glamorous ones before it`,
      verdict: 'Yes',
    },
    {
      feedback: `This is funny but a bit alarming! Alcohol at wake-up? Are you an alcoholic?`,
      verdict: 'No',
    },
    {
      feedback: `This shows you're able to laugh at yourself. It was established earlier that you're classy and stylish, so this is a good change of pace`,
      verdict: 'Yes',
    },
    {
      feedback: `Awesome glamor shot! Great way to end!`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: hollyBio._id,
    vitalInfo: { ...hollyBio.vitalInfo },
    prompts: [
      { ...hollyBio.prompts[0] },
      { ...hollyBio.prompts[1] },
      { ...hollyBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: [],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `No professional or university background has me wondering what you do all day`,
      verdict: 'No', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `Way too overtly golddiggery`,
        verdict: 'No', 
      },
      {
        feedback: `I'm sure you can add some sort of humorous twist to this, but it's a good premise`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `This is a funny question and it will also give you insight into how the guy thinks about women`,
        verdict: 'Very', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Holly is beautiful, classy, and funny, but a bit of an enigma, and perhaps a golddigger`,
    good: `The style. The photos where you're smiling. The fact that you're beautiful. And in addition to the beauty fun`,
    notGood: `The enigma of what you do with your time coupled with the golddiggery prompt responses`,
    verdict: `Overall you'll get good matches from your beauty and charisma, but to get the type of matches you actually want, you'll have to change your prompt responses and the photo of you drinking upon waking up`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...frodoReviewerReviewHinge },
  reviewerProfile: { ...frodoReviewerProfile },
  bioItems: { ...hollyBio },
  mediaItems: [ ...hollyMediaArray ],
}

export const luigiProfileReviewBumble = {
  _id: 'luigiProfileReviewBumbleId',
  userId: 'hollyUserId',
  userEmail: 'holly@email.com',
  datingProfileId: 'hollyDatingProfileBumbleId',
  reviewerProfileId: 'luigiReviewerProfileId',
  reviewerEmail: 'luigi@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: hollyMediaArray[11]._id,
      mediaItemURL: hollyMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[11].type,
      caption: hollyMediaArray[11].captions[0],
      subcaption: hollyMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[9]._id,
      mediaItemURL: hollyMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[9].type,
      caption: hollyMediaArray[9].captions[0],
      subcaption: hollyMediaArray[9].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[12]._id,
      mediaItemURL: hollyMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[12].type,
      caption: hollyMediaArray[12].captions[0],
      subcaption: hollyMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[5]._id,
      mediaItemURL: hollyMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[5].type,
      caption: hollyMediaArray[5].captions[0],
      subcaption: hollyMediaArray[5].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[4]._id,
      mediaItemURL: hollyMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[4].type,
      caption: hollyMediaArray[4].captions[0],
      subcaption: hollyMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[1]._id,
      mediaItemURL: hollyMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[1].type,
      caption: hollyMediaArray[1].captions[0],
      subcaption: hollyMediaArray[1].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look stylish! And the pastry gives it a humorous touch! Good start!`,
      verdict: 'Very',
    },
    {
      feedback: `Amazing smile! And stylish hat! You look great here!`,
      verdict: 'Very',
    },
    {
      feedback: `A fun casual picture is a nice light touch after the two glamorous ones before it`,
      verdict: 'Yes',
    },
    {
      feedback: `This is funny but a bit alarming! Alcohol at wake-up? Are you an alcoholic?`,
      verdict: 'No',
    },
    {
      feedback: `This shows you're able to laugh at yourself. It was established earlier that you're classy and stylish, so this is a good change of pace`,
      verdict: 'Yes',
    },
    {
      feedback: `Awesome glamor shot! Great way to end!`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: hollyBio._id,
    vitalInfo: { ...hollyBio.vitalInfo },
    prompts: [
      { ...hollyBio.prompts[0] },
      { ...hollyBio.prompts[1] },
      { ...hollyBio.prompts[2] }
    ],
    aboutMe: hollyBio.aboutMe[0],
    hobbies: [hollyBio.hobbies[0], hollyBio.hobbies[1], hollyBio.hobbies[2], hollyBio.hobbies[3], hollyBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `No professional or university background has me wondering what you do all day`,
      verdict: 'No', 
    },
    aboutMeFeedback: {
      feedback: `Again, a bit golddiggery, but it's a good premise, and I bet you can add a quip to it to make it fun`,
      verdict: 'Somewhat', 
    },
    promptsFeedback: [
      {
        feedback: `Way too overtly golddiggery`,
        verdict: 'No', 
      },
      {
        feedback: `I'm sure you can add some sort of humorous twist to this, but it's a good premise`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `This is a funny question and it will also give you insight into how the guy thinks about women`,
        verdict: 'Very', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Holly is beautiful, classy, and funny, but a bit of an enigma, and perhaps a golddigger`,
    good: `The style. The photos where you're smiling. The fact that you're beautiful. And in addition to the beauty fun`,
    notGood: `The enigma of what you do with your time coupled with the golddiggery prompt responses`,
    verdict: `Overall you'll get good matches from your beauty and charisma, but to get the type of matches you actually want, you'll have to change your prompt responses and the photo of you drinking upon waking up`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...luigiReviewerReviewBumble },
  reviewerProfile: { ...luigiReviewerProfile },
  bioItems: { ...hollyBio },
  mediaItems: [ ...hollyMediaArray ],
}

export const gatsbyProfileReviewTinder = {
  _id: 'gatsbyProfileReviewTinderId',
  userId: 'hollyUserId',
  userEmail: 'holly@email.com',
  datingProfileId: 'hollyDatingProfileTinderId',
  reviewerProfileId: 'gatsbyReviewerProfileId',
  reviewerEmail: 'gatsby@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: hollyMediaArray[11]._id,
      mediaItemURL: hollyMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[11].type,
      caption: hollyMediaArray[11].captions[0],
      subcaption: hollyMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[9]._id,
      mediaItemURL: hollyMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[9].type,
      caption: hollyMediaArray[9].captions[0],
      subcaption: hollyMediaArray[9].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[12]._id,
      mediaItemURL: hollyMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[12].type,
      caption: hollyMediaArray[12].captions[0],
      subcaption: hollyMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[5]._id,
      mediaItemURL: hollyMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[5].type,
      caption: hollyMediaArray[5].captions[0],
      subcaption: hollyMediaArray[5].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[4]._id,
      mediaItemURL: hollyMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[4].type,
      caption: hollyMediaArray[4].captions[0],
      subcaption: hollyMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[1]._id,
      mediaItemURL: hollyMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[1].type,
      caption: hollyMediaArray[1].captions[0],
      subcaption: hollyMediaArray[1].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look stylish! And the pastry gives it a humorous touch! Good start!`,
      verdict: 'Very',
    },
    {
      feedback: `Amazing smile! And stylish hat! You look great here!`,
      verdict: 'Very',
    },
    {
      feedback: `A fun casual picture is a nice light touch after the two glamorous ones before it`,
      verdict: 'Yes',
    },
    {
      feedback: `This is funny but a bit alarming! Alcohol at wake-up? Are you an alcoholic?`,
      verdict: 'No',
    },
    {
      feedback: `This shows you're able to laugh at yourself. It was established earlier that you're classy and stylish, so this is a good change of pace`,
      verdict: 'Yes',
    },
    {
      feedback: `Awesome glamor shot! Great way to end!`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: hollyBio._id,
    vitalInfo: { ...hollyBio.vitalInfo },
    prompts: [
      { ...hollyBio.prompts[0] },
      { ...hollyBio.prompts[1] },
      { ...hollyBio.prompts[2] }
    ],
    aboutMe: hollyBio.aboutMe[0],
    hobbies: [hollyBio.hobbies[0], hollyBio.hobbies[1], hollyBio.hobbies[2], hollyBio.hobbies[3], hollyBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `No professional or university background has me wondering what you do all day`,
      verdict: 'No', 
    },
    aboutMeFeedback: {
      feedback: `Again, a bit golddiggery, but it's a good premise, and I bet you can add a quip to it to make it fun`,
      verdict: 'Somewhat', 
    },
    promptsFeedback: [
      {
        feedback: `Way too overtly golddiggery`,
        verdict: 'No', 
      },
      {
        feedback: `I'm sure you can add some sort of humorous twist to this, but it's a good premise`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `This is a funny question and it will also give you insight into how the guy thinks about women`,
        verdict: 'Very', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Holly is beautiful, classy, and funny, but a bit of an enigma, and perhaps a golddigger`,
    good: `The style. The photos where you're smiling. The fact that you're beautiful. And in addition to the beauty fun`,
    notGood: `The enigma of what you do with your time coupled with the golddiggery prompt responses`,
    verdict: `Overall you'll get good matches from your beauty and charisma, but to get the type of matches you actually want, you'll have to change your prompt responses and the photo of you drinking upon waking up`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...gatsbyReviewerReviewTinder },
  reviewerProfile: { ...gatsbyReviewerProfile },
  bioItems: { ...hollyBio },
  mediaItems: [ ...hollyMediaArray ],
}